import specialP from "../_ApiConn/apiSpecialPages";



const getSpecialPageByName = async (pageName) => {
    let dFromF = await specialP.getSpecialPageByName(pageName);
    dFromF.pageName = dFromF.mainHead
    return (dFromF);
}


const getStaticPageByName = async (pageName) => {
    let dFromF = await specialP.getStaticPageByName(pageName);
    return (dFromF);
}



export default {
    getSpecialPageByName,
    getStaticPageByName

};